import './MentorsStyles.css'
import image from '../../images/mentor-image.png'
import React from 'react'

const Mentors = () => {
  return (
    <div className="section-2">
      {/* <div className="mentors">
        <h2>Mentors</h2>
        <div className="mentor-container">
          <div className="mentor-card">
            <img className="mentor-img" src={image} alt="mentor image" />
            <div className="mentor-details">
              <p>Mohammed Shajin P</p>
              <p>Mentor</p>
            </div>
          </div>
          <div className="mentor-card">
            <img className="mentor-img" src={image} alt="mentor image" />
            <div className="mentor-details">
              <p>Mohammed Shajin P</p>
              <p>Mentor</p>
            </div>
          </div>
          <div className="mentor-card">
            <img className="mentor-img" src={image} alt="mentor image" />
            <div className="mentor-details">
              <p>Mohammed Shajin P</p>
              <p>Mentor</p>
            </div>
          </div>
          <div className="mentor-card">
            <img className="mentor-img" src={image} alt="mentor image" />
            <div className="mentor-details">
              <p>Mohammed Shajin P</p>
              <p>Mentor</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="about">
        <h2>About</h2>
        <p>
          കഴിഞ്ഞ നാലര ദശകത്തിലേറെയായി സാമൂഹിക - സാംസ്കാരിക മേഖലകളിൽ
          ക്രിയാത്മകമായ ഇടപെടലുകൾ നടത്തുകയും, വിദ്യാഭ്യാസ രംഗത്ത് മികച്ച മാതൃകകൾ
          സൃഷ്ടിക്കുകയും ചെയ്ത ഒരു ബൃഹത് പ്രസ്ഥാനമാണ് കൊടുവള്ളി മുസ്ലിം ഓർഫനേജ്.
          അനാഥരും അഗതികളും അടക്കം സമർത്ഥരായ വിദ്യാർത്ഥികളും, ചെമ്മാട് ദാറുൽ ഹുദാ
          ഇസ്ലാമിക് യൂണിവേഴ്സിറ്റിയോട് അഫിലിയേറ്റു ചെയ്ത കെ.എം. ഒ ഇസ്‌ലാമിക്
          അക്കാദമിയിലെ 250 ഓളം വിദ്യാർഥികളും ഇവിടെ സൗജന്യമായി താമസിച്ച് പഠിച്ചു
          കൊണ്ടിരിക്കുന്നു.പൊതുജന പങ്കാളിത്തതോടെയും ഉദാര മനസ്കരുടെ
          സഹായത്താലുമാണ് ഈ സ്ഥാപനം നാളിതുവരെയും പ്രവർത്തിച്ചു വരുന്നത്.
        </p>
      </div>
    </div>
  );
}

export default Mentors
